export default "__VITE_ASSET__d946e8c7__"